import React from 'react';

export default function ArrowIcon(): JSX.Element {
  return (
    <svg
      width="10px"
      height="5px"
      viewBox="0 0 10 5"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(-48.000000, -7.000000)">
        <path
          strokeWidth="0"
          d="M57.998,9.46 C58.001,9.329 57.953,9.197 57.853,9.097 L55.902,7.147 C55.707,6.951 55.391,6.951 55.195,7.147 C55,7.342 55,7.658 55.195,7.854 L56.311,8.969 L48.5,8.969 C48.224,8.969 48,9.193 48,9.469 C48,9.745 48.224,9.969 48.5,9.969 L56.311,9.969 L55.195,11.085 C55,11.28 55,11.597 55.195,11.792 C55.391,11.987 55.707,11.987 55.902,11.792 L57.853,9.841 C57.953,9.741 58.001,9.609 57.998,9.478 C57.998,9.475 58,9.472 58,9.469 C58,9.466 57.998,9.463 57.998,9.46"
        />
      </g>
    </svg>
  );
}
